import React from 'react';
import {
  ColumnContainer,
  Heading,
  LoginBackImage,
  LoginContainer,
  LoginWrapper,
  Logo,
  LogoWrap,
  PartialWrapLoginBackImage,
  Wrap,
} from 'pages/login/login_style';
import ForgetPasswordComponent from 'component/login_components/forgetPassword';
import { useSelector } from 'react-redux';

const ForgotPassword = () => {
  const { defaultTheme } = useSelector((state) => state.themes);

  return (
    <div className='body-content'>
      {defaultTheme === 'globlue' ? (
        <LoginBackImage className='forgot-background-image'>
          <ColumnContainer className='globlue forgot-column-container'>
            <div className='column' />
            <div className='column'>
              <Wrap className='forgot-wrapper'>
                <LoginContainer className='forgot-container'>
                  <LogoWrap className='forgot-logo-wrap'>
                    <Logo alt='Logo' className='forgot-logo' />
                  </LogoWrap>
                  <Heading className={`${defaultTheme} forgot-heading`}>Forgot Password</Heading>
                  <ForgetPasswordComponent theme={defaultTheme} />
                </LoginContainer>
              </Wrap>
            </div>
          </ColumnContainer>
        </LoginBackImage>
      ) : defaultTheme === 'mornglow' ? (
        <PartialWrapLoginBackImage className='mornglow forgot-partial-wrapper'>
          <ColumnContainer className='mornglow forgot-column-container'>
            <div className='column'>
              <Wrap className='logoleft forgot-wrapper'>
                <Logo className='leftsideLogo forgot-logo' alt='Logo' />
                <LoginWrapper className={`${defaultTheme} forgot-inside-wrap`}>
                  <LoginContainer className='forgot-container'>
                    <Heading className={`${defaultTheme} forgot-heading`}>Forgot Password</Heading>
                    <ForgetPasswordComponent theme={defaultTheme} />
                  </LoginContainer>
                </LoginWrapper>
              </Wrap>
            </div>
          </ColumnContainer>
          <LoginBackImage className='forgot-background-image'></LoginBackImage>
        </PartialWrapLoginBackImage>
      ) : defaultTheme === 'nitrate' ? (
        <LoginBackImage className='forgot-background-image'>
          <ColumnContainer className='nitrate forgot-column-container'>
            <Wrap className='forgot-wrapper'>
              <LoginWrapper className={`${defaultTheme} forgot-inside-wrap`}>
                <LoginContainer className='forgot-container'>
                  <LogoWrap className='forgot-logo-wrap'>
                    <Logo alt='Logo' className='forgot-logo' />
                  </LogoWrap>
                  <Heading className={`${defaultTheme} forgot-heading`}>Forgot Password</Heading>
                  <ForgetPasswordComponent theme={defaultTheme} />
                </LoginContainer>
              </LoginWrapper>
            </Wrap>
          </ColumnContainer>
        </LoginBackImage>
      ) : defaultTheme === 'teamring' ? (
        <PartialWrapLoginBackImage className='forgot-partial-wrapper'>
          <LoginBackImage className='forgot-background-image'>
            <Wrap className='logoleft forgot-wrapper'>
              <Logo className='leftsideLogo forgot-logo' alt='Logo' />
            </Wrap>
          </LoginBackImage>
          <ColumnContainer className='teamring forgot-column-container'>
            <Wrap className='forgot-wrapper-second'>
              <LoginWrapper className={defaultTheme}>
                <LoginContainer className='forgot-container'>
                  <Heading className={`${defaultTheme} forgot-heading`}>Forgot Password</Heading>
                  <ForgetPasswordComponent theme={defaultTheme} />
                </LoginContainer>
              </LoginWrapper>
            </Wrap>
          </ColumnContainer>
        </PartialWrapLoginBackImage>
      ) : (
        ''
      )}
    </div>
  );
};

export default ForgotPassword;
